import React from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Home from "./Home";
import Profile from "./Profile";
import Campaigns from "./Campaigns";
import Privacy from "./Privacy";
// import Terms from "./Terms";
import NotFound from "./NotFound";
import Account from "./Account";
import CampaignForm from "./CampaignForm";
import Rewards from "./Rewards";
import ResetPassword from "./ResetPassword";
import VerifyEmail from "./VerifyEmail";
import { connect } from "react-redux";
import { updateUserMessage } from "../actions/common.actions";
import LinearProgress from "@material-ui/core/LinearProgress";
import Style from "styled-components";

import CampaignClaim from "./CampaignClaim";
import RewardClaim from "./RewardClaim";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LinearProgressStyled = Style(LinearProgress)`
  position: fixed!important;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  z-index: 999999999;
  div {
    background-color: #3F3F3F
  }
`;

const ComponentsMap = {
  Home,
  Profile,
  Campaigns,
  Privacy,
  // Terms,
  Account,
  NotFound,
  CampaignForm,
  Rewards,
  ResetPassword,
  VerifyEmail,
  CampaignClaim,
  RewardClaim,
};

const Wrapper = (props) => {
  const Component = ComponentsMap[props.component];
  return (
    <React.Fragment>
      <Component />
      {props.loading && <LinearProgressStyled />}
      <Snackbar
        open={!!props.userMessage}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        autoHideDuration={6000}
        onClose={() => {
          props.updateUserMessage(null);
        }}
      >
        <Alert
          onClose={() => {
            props.updateUserMessage(null);
          }}
          severity={
            props.userMessage && props.userMessage.type
              ? props.userMessage.type.toLowerCase()
              : ""
          }
        >
          {props.userMessage &&
            props.userMessage.message &&
            typeof props.userMessage.message != "string" &&
            props.userMessage.message.map((el) => {
              return <li key={el}>{el}</li>;
            })}
          {props.userMessage &&
            props.userMessage.message &&
            typeof props.userMessage.message === "string" && (
              <li>{props.userMessage.message}</li>
            )}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userMessage: state.common.userMessage,
    loading: state.common.loading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserMessage: (payload) => dispatch(updateUserMessage(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);
